import { useRef } from 'react';

import { stripNumberingFromString } from '@blockworks/platform';
import { AssetTab } from '@blockworks/platform/api/strapi';
import { RenderMarkdown } from '@blockworks/ui/legacy';

type PriceAboutDetailProps = {
    code: string;
    hidePageTitle?: boolean;
    about: AssetTab | null;
};

const PriceAboutDetail = (props: PriceAboutDetailProps) => {
    const { hidePageTitle, about } = props;
    const deepDiveRef = useRef<HTMLDivElement>(null);

    if (!about) {
        return null;
    }

    return (
        <div ref={deepDiveRef} className="flex flex-col border-t p-8 pt-0">
            <div>
                {!hidePageTitle && (
                    <h3 className="truncate text-xl font-headline pt-8 pb-4 leading-9">
                        {stripNumberingFromString(about.title)}
                    </h3>
                )}
                <RenderMarkdown
                    text={about.content ?? ''}
                    className="post-content overflow-auto break-words text-dark font-normal prose prose-base"
                    fullWidth
                />
            </div>
        </div>
    );
};

export default PriceAboutDetail;
